import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";

export const clickCutleryChecked = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CUTLERY_TRUE,
    });
};

export const clickCutleryUnChecked = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CUTLERY_FALSE,
    });
};

export const impressionCutleryShown = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CUTLERY_SHOWN,
    });
};

export const impressionCutleryNotShown = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CUTLERY_NOT_SHOWN,
    });
};

export const impressionCutleryOptInWidget = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    flag: number,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CUTLERY_OPT_IN_WIDGET,
        label: flag,
    });
};

export const clickCutleryOptInWidget = (clickEvent: AnalyticsContextValue["clickEvent"], flag: number): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CUTLERY_OPT_IN_WIDGET,
        label: flag,
    });
};
